import * as types from "@/store/mutation-types";

const state = {
  currentAction: {},
  actionTags: [],
  actionMakers: [],
  currentActionProducts: [],
  currentActionGifts: [],
}

const actions = {
  fetchAction({ commit }, array) {
    commit(types.FETCH_ACTION_SUCCESS, array)
  }
}

const mutations = {
  [types.FETCH_ACTION_SUCCESS](state, array) {
    const [action, tags, makers, products, gifts] = array

    state.currentAction = action;
    state.actionTags = tags;
    state.actionMakers = makers;
    state.currentActionProducts = products;
    state.gifts = gifts;
  },
}

const getters = {
  currentAction: state => state.currentAction,
  actionTags: state => state.actionTags,
  actionMakers: state => state.actionMakers,
  currentActionProducts: state => state.currentActionProducts,
  currentActionGifts: state => state.currentActionGifts
}

export default {
  state,
  actions,
  mutations,
  getters
}